import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";
import { SERVICE_NAME } from "@zapier/utils";

export enum FavoriteOptions {
  Add = "add",
  Remove = "remove",
}

interface EmitOptions {
  optionSelected: FavoriteOptions;
  interactionRawText?: string;
}

export function useEmitFavoriteEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    ({ optionSelected, interactionRawText }: EmitOptions) => {
      emitUserInteractionEvent({
        accountId,
        eventAction: "click",
        interactionName: UserInteractionName.Favorite,
        interactionRawText,
        optionSelected,
        systemName: SERVICE_NAME,
      });
    },
    [accountId],
  );

  return {
    emit,
  };
}
